import { isHomePage, isSectionHome } from '../../utils/aem-utils';
import { isInjectedHPInView } from '../../utils/injected-hp-utils';
import { allowBodyScroll, preventBodyScroll } from '../../utils/body-scroll';
import { isLargeScreen } from '../../utils/mediaquery-utils';
import logger from '../../services/logging/logging-service';
import { skyFoundationSettings } from '../../services/configs/configs-service';

import { renderLocalNavigation } from './local-navigation-renderers';

/**
 * Global variabiles
 */
let $localTitleText;
let isLocalNavOpen;
let observer;
let isIntersecting;
let isGlobalNavOpen;
let isLocalTitleVisible;

/**
 * this is the
 *function that opens the local menu
 */
const onclickLocal = () => {
  const $localNav = document.querySelector('.j-local-nav');
  const $bodyNav = document.body;
  const $clickArea = document.querySelector('.j-local-nav__trigger');
  const $localNavClose = document.querySelector('.j-local-nav__trigger .icon__svg--close').parentNode;
  const $localNavOpen = document.querySelector('.j-local-nav__trigger .icon__svg--menu').parentNode;
  const $elementFeatured = document.querySelector('.j-local-nav__featured');
  const $elementBottom = document.querySelector('.j-local-nav__bottom');
  const $elementSecondary = document.querySelector('.j-local-nav__secondary');
  const $localTitle = document.querySelector('.j-local-title');
  const $logoHeader = document.querySelector('.j-local-nav-logo');

  if ($localTitle) {
    $localTitleText = document.querySelector('.j-local-title-text').childNodes;
  }

  if ($localNav) {
    $clickArea.addEventListener('click', () => {
      isLocalNavOpen = $localNav.classList.contains('is-active__wrapper');
      isGlobalNavOpen = $bodyNav.classList.contains('is-global-nav-open');
      if (isGlobalNavOpen) {
        $bodyNav.classList.toggle('is-global-nav-open');
      }
      if (isLocalNavOpen) {
        allowBodyScroll();
        $localNav.classList.toggle('is-active__wrapper');
        $localNavOpen.classList.add('icon__svg--show');
        $localNavOpen.classList.remove('icon__svg--hide');
        $localNavClose.classList.add('icon__svg--hide');
        $localNavClose.classList.remove('icon__svg--show');
        if ($elementFeatured) {
          if (isInjectedHPInView()) {
            $elementFeatured.classList.remove('is-active--mob', 'is-active');
            $elementFeatured.classList.add('is-visibile');
          } else {
            $elementFeatured.classList.toggle('is-active--mob');
            $elementFeatured.classList.toggle('is-active');
          }
        }
        if ($elementBottom) {
          $elementBottom.classList.toggle('is-active');
        }
        if ($elementSecondary) {
          $elementSecondary.classList.toggle('is-active');
        }
        if ($localTitle) {
          if (isIntersecting && !isInjectedHPInView() && $elementFeatured && $clickArea && $logoHeader) {
            $elementFeatured.classList.add('has-scroll-visible');
          }
          if (isLargeScreen() && !isInjectedHPInView() && isLocalTitleVisible) {
            $localTitle.classList.add('has-visibile');
          }
        }
      } else {
        preventBodyScroll();
        $localNav.classList.toggle('is-active__wrapper');
        $localNavOpen.classList.remove('icon__svg--show');
        $localNavOpen.classList.add('icon__svg--hide');
        $localNavClose.classList.remove('icon__svg--hide');
        $localNavClose.classList.add('icon__svg--show');
        if ($elementFeatured) {
          $elementFeatured.classList.toggle('is-active--mob');
          $elementFeatured.classList.toggle('is-active');
        }
        if ($elementBottom) {
          $elementBottom.classList.toggle('is-active');
        }
        if ($elementSecondary) {
          $elementSecondary.classList.toggle('is-active');
        }
        if ($localTitle) {
          if (isIntersecting) {
            if ($elementFeatured && $clickArea && $logoHeader) {
              $elementFeatured.classList.remove('has-scroll-visible');
            }
          }
          if (isLargeScreen() && !isInjectedHPInView() && isLocalTitleVisible) {
            $localTitle.classList.remove('has-visibile');
          }
        }
      }
    });
  }
};

/**
 * this is the
 *function that move the titelo of the articles in the local menu
 */
const moveTitle = () => {
  const $heroTitle = document.querySelector('.j-hero__title');
  const $localTitle = document.querySelector('.j-local-title');
  const $localTitleText = document.querySelector('.j-local-title-text').childNodes;
  const $elementFeatured = document.querySelector('.j-local-nav__featured');
  const $clickArea = document.querySelector('.j-local-nav__trigger');
  const $logoHeader = document.querySelector('.j-local-nav-logo');

  let titleText;
  if ($heroTitle) {
    titleText = $heroTitle.innerText;
  }
  if ($localTitle && titleText) {
    if (isLargeScreen()) {
      $localTitle.classList.add('has-visibile');
      isLocalTitleVisible = true;
    }
    $localTitleText[1].innerHTML = titleText;
    if ($elementFeatured && $clickArea && $logoHeader) {
      $elementFeatured.classList.add('has-scroll-visible');
    }
  }
};

/**
 * this is the
 *function that set the observer for move title on local navigation.
 */

const heroView = () => {
  const $heroHook = document.querySelector('.j-intro');
  const $localTitle = document.querySelector('.j-local-title');
  const $elementFeatured = document.querySelector('.j-local-nav__featured');
  const $clickArea = document.querySelector('.j-local-nav__trigger');
  const $logoHeader = document.querySelector('.j-local-nav-logo');
  const $localNav = document.querySelector('.j-local-nav');

  if ($heroHook) {
    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if ($localTitle) {
            $localTitle.classList.remove('has-visibile');
            isLocalTitleVisible = false;
          }
          if ($elementFeatured && $clickArea && $logoHeader) {
            $elementFeatured.classList.remove('has-scroll-visible');
          }
          isIntersecting = false;
        } else {
          isLocalNavOpen = $localNav.classList.contains('is-active__wrapper');
          if (!isLocalNavOpen && !isHomePage() && !isSectionHome()) {
            moveTitle();
          }
          isIntersecting = true;
        }
      });
    };

    observer = new IntersectionObserver(callback);

    observer.observe($heroHook);
  }
};

export const init = () => {
  const localNavUrl = skyFoundationSettings.getLocalNavUrl();
  fetch(localNavUrl)
    .then((response) => response.json())
    .then((localNavData) => {
      logger.info('Data fetched', localNavData.data);
      renderLocalNavigation(localNavData.data);
      onclickLocal();
      heroView();
    })
    .catch((error) => console.error('Error fetching data:', error));
};
